// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function timezone_config_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var config = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "config"), null));
  if (config.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              config: config._0
            }
          };
  }
  var e = config._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".config" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function currency_config_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var iso_code = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "iso_code"), null));
  if (iso_code.TAG === /* Ok */0) {
    var iso_numeric = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "iso_numeric"), null));
    if (iso_numeric.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var symbol = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "symbol"), null));
        if (symbol.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    iso_code: iso_code._0,
                    iso_numeric: iso_numeric._0,
                    name: name._0,
                    symbol: symbol._0
                  }
                };
        }
        var e = symbol._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".symbol" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = iso_numeric._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".iso_numeric" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = iso_code._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".iso_code" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var currency_config = currency_config_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency_config"), null));
  if (currency_config.TAG === /* Ok */0) {
    var mobile_validation_regex_str = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile_validation_regex_str"), null));
    if (mobile_validation_regex_str.TAG === /* Ok */0) {
      var timezone_config = timezone_config_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timezone_config"), null));
      if (timezone_config.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  currency_config: currency_config._0,
                  mobile_validation_regex_str: mobile_validation_regex_str._0,
                  timezone_config: timezone_config._0
                }
              };
      }
      var e = timezone_config._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".timezone_config" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = mobile_validation_regex_str._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".mobile_validation_regex_str" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = currency_config._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".currency_config" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

export {
  timezone_config_decode ,
  currency_config_decode ,
  t_decode ,
  
}
/* No side effect */
